<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'AGREEMENT.AGREEMENT_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div></div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetSearchInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            {{ agreement.id }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchID">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>ID</mat-label>
              <input matInput [placeholder]="'ID'" [(ngModel)]="searchIDInput" />
              <button
                *ngIf="searchIDInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchIDInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            {{ agreement.name }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchName">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Name</mat-label>
              <input matInput [placeholder]="'Name'" [(ngModel)]="searchNameInput" />
              <button
                *ngIf="searchNameInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchNameInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="type">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            {{ agreement.type }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchType">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Type</mat-label>
              <input matInput [placeholder]="'Type'" [(ngModel)]="searchTypeInput" />
              <button
                *ngIf="searchTypeInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchTypeInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getStatusClass(agreement.status.toLowerCase())
              }} label-inline text-center"
            >
              {{ getStatusLabel(agreement.status) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchStatus">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Status</mat-label>
              <mat-select [(value)]="searchStatusSelect" [placeholder]="'Status'">
                <mat-option value="">All</mat-option>
                <mat-option value="SENT">Sent</mat-option>
                <mat-option value="REVOKED">Revoked</mat-option>
                <mat-option value="SIGNED">Signed</mat-option>
                <mat-option value="COMPLETED">Completed</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="dateSent">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Date Sent</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            {{ agreement.date_sent | date : 'MM-dd-yy, h:mm a' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDateSent">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Date Sent</mat-label>
              <input
                matInput
                [(ngModel)]="searchDateSentInput"
                [matDatepicker]="searchDateSentPicker"
                [placeholder]="'Date Sent'"
              />
              <button
                *ngIf="searchDateSentInput"
                matSuffix
                mat-icon-button
                (click)="searchDateSentInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle
                *ngIf="!searchDateSentInput"
                matSuffix
                [for]="searchDateSentPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchDateSentPicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="voidDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Void Date</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            {{ agreement.void_date | date : 'MM-dd-yy, h:mm a' }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchVoidDate">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Void Date</mat-label>
              <input
                matInput
                [(ngModel)]="searchVoidDateInput"
                [matDatepicker]="searchVoidDatePicker"
                [placeholder]="'Void Date'"
              />
              <button
                *ngIf="searchVoidDateInput"
                matSuffix
                mat-icon-button
                (click)="searchVoidDateInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle
                *ngIf="!searchVoidDateInput"
                matSuffix
                [for]="searchVoidDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchVoidDatePicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="voidReason">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Void Reason</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            {{ agreement.void_reason }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchVoidReason">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>Void Reason</mat-label>
              <input matInput [placeholder]="'Void Reason'" [(ngModel)]="searchVoidReasonInput" />
              <button
                *ngIf="searchVoidReasonInput"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="searchVoidReasonInput = ''"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let agreement">
            <ng-template ngxPermissionsOnly="canViewAgreement">
              <button
                matTooltip="View Agreement"
                class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
                (click)="viewAgreementButtonOnClick(agreement)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/visible.svg"
                  class="svg-icon svg-icon-md svg-icon-success"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canRemindAgreement">
              <button
                [disabled]="getReminderButtonState(agreement).disabled"
                [matTooltip]="getReminderMatTooltip(agreement)"
                class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
                (click)="remindAgreementButtonOnClick(agreement)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/marketing.svg"
                  class="svg-icon svg-icon-md svg-icon-primary"
                ></span>
              </button>
            </ng-template>
            <ng-template ngxPermissionsOnly="canRevokeAgreement">
              <button
                [disabled]="['REVOKED'].includes(agreement.status.toUpperCase())"
                matTooltip="Revoke Agreement"
                class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
                (click)="revokeAgreementButtonOnClick(agreement)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                  class="svg-icon svg-icon-md svg-icon-danger"
                ></span>
              </button>
            </ng-template>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              type="button"
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light w-50 m-1"
              (click)="resetSearchBar($event)"
            >
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="pageSize || 25"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
